import { isPlatform } from "@ionic/core";
import { Capacitor } from "@capacitor/core";
import { Directory, Encoding, Filesystem } from "@capacitor/filesystem";
import { CapacitorSQLite, DBSQLiteValues, SQLiteConnection } from "@capacitor-community/sqlite";

import { useUserStore } from "@/stores/user";
import { usePersistentStore } from "@/stores/persistent";

import { useApi } from "@/composables/useApi";

import { pushNotifications } from "@/functions/pushNotifications";
import { setPreference } from "@/functions/preferences";

import { MeResponse } from "@/types/user";

const checkOldToken = async (): Promise<void | boolean> => {
    const persistentStore = usePersistentStore()
    const userStore = useUserStore()

    if (userStore.sessionInfo?.sessionToken || persistentStore?.oldTokenChecked || !Capacitor.isNativePlatform()) return persistentStore.oldTokenChecked = true
    let response = undefined

    try {
        if (isPlatform('ios')) {
            const file = await Filesystem.readFile({
                path: 'RCTAsyncLocalStorage_V1/manifest.json',
                directory: Directory.Documents,
                encoding: Encoding.UTF8
            })
            const fileContent = JSON.parse(JSON.stringify(file.data))

            if (!fileContent.JWT) return persistentStore.oldTokenChecked = true

            response = await userStore.loginByToken(fileContent.JWT)
        } else {
            // TODO: Update logic for store token
            const dbFile = await Filesystem.stat({ path: '../databases/RKStorage', directory: Directory.Data })
            if (!dbFile?.uri) return persistentStore.oldTokenChecked = true//no db file found

            const sqlite = new SQLiteConnection(CapacitorSQLite)
            const path = dbFile.uri.split('://')[1]//.split('files/../')[0]
            const db = await sqlite.createNCConnection(path, 2)

            await db.open()

            const tokenValue: DBSQLiteValues = await db.query(`SELECT *
                                                               FROM catalystLocalStorage
                                                               WHERE key ='JWT'`)

            if (!tokenValue.values) return persistentStore.oldTokenChecked = true

            await db.close()

            response = await userStore.loginByToken(tokenValue.values[0].value)
        }
    } catch (e: unknown) {
        console.error(e)
    }

    if (!response) return persistentStore.oldTokenChecked = true

    persistentStore.oldTokenChecked = true

    if (response?.data.access_token) {
        if (!userStore.sessionInfo) userStore.sessionInfo = new MeResponse()
        userStore.sessionInfo.sessionToken = response?.data.access_token
        await userStore.getMe()
        await setPreference('userStore', JSON.stringify(userStore.$state))
    }
}

export async function initApp(): Promise<void> {
    const userStore = useUserStore()
    if (Capacitor.isNativePlatform()) {
        const { registerPushNotificationListener } = pushNotifications()
        await registerPushNotificationListener()
    }

    // write Preferences to pinia
    await userStore.localToPinia()
    const { initApi } = useApi()
    await initApi()
    await checkOldToken()
}
